import React from 'react';
import { cn } from '../../utils/cn';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?:
    | 'default'
    | 'secondary'
    | 'destructive'
    | 'outline'
    | 'success'
    | 'warning'
    | 'blue'
    | 'green'
    | 'yellow'
    | 'purple'
    | 'gray'
    | 'brand'
    | 'error'
    | 'info';
  size?: 'sm' | 'default' | 'lg';
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = 'default', size = 'default', ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center rounded-full font-medium',

          {
            'px-2 py-0.5 text-xs': size === 'sm',
            'px-2.5 py-0.5 text-xs': size === 'default',
            'px-3 py-1 text-sm': size === 'lg',
          },

          {
            'bg-surface-2 text-text-primary': variant === 'default',
            'bg-surface-2 text-text-secondary': variant === 'secondary',
            'bg-error/10 text-error': variant === 'destructive' || variant === 'error',
            'bg-transparent text-text-secondary border border-border': variant === 'outline',
            'bg-success/10 text-success': variant === 'success' || variant === 'green',
            'bg-warning/10 text-warning': variant === 'warning' || variant === 'yellow',
            'bg-info/10 text-info': variant === 'blue' || variant === 'info',
            'bg-purple-50 text-purple-700': variant === 'purple',
            'bg-surface-2 text-text-tertiary': variant === 'gray',
            'bg-brand-light text-brand': variant === 'brand',
          },

          className
        )}
        {...props}
      />
    );
  }
);

Badge.displayName = 'Badge';

export { Badge };
